import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { FiltersFormFeatureAuth } from 'system/view-models/feature-auth-list';

export const transformDataset = (values: FiltersFormFeatureAuth): string => {
  const { orders, ...otherValues } = values;

  const transformedFilters: OperationObject = {
    codice: {
      value: otherValues.code,
      operation: Operation.EQUALS,
    },
    descrizione: {
      value: otherValues.description,
      operation: Operation.LIKE,
    },
  };

  const ordersToTransform = orders || {};
  const ordersMapped: Order = {
    codiceFeature: ordersToTransform.code,
    descrizioneTipoFeature: ordersToTransform.description,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
